export default class BPBuchungBestellartRequest {
  id: string
  bestellart: string
}
